import {connect} from 'react-redux';
import {MainScene as Component} from './MainScene';
import {FILES} from '../../Data';
import {
  setSimulationLevel,
  endTour,
  incrementTour,
  setNoteBookSection
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    showLevelModal: state.notebook.showLevelModal,
    levelSelected: !state.notebook.showLevelModal,
    currentSection: state.notebook.currentSection,
    stepIndex: state.notebook.stepIndex,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setLevel: (levelId) => {
      dispatch(setSimulationLevel({
          levelData: FILES[levelId.value],
          levelId: levelId
      }));
    },
    endTour: (data) => {
      dispatch(endTour(data));
    },
    incrementTour: (data) => {
      dispatch(incrementTour(data));
    },
    setNoteBookSection: (data) => {
      dispatch(setNoteBookSection(data));
    },
  };
}

export const MainScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
